const dateLocale = require('date-fns/locale/fr');

export default {
  dateLocale,
};
